import { Adapter as t } from "../../../../adapter.js";
import { TicketHistoryPaymentModel as n } from "./ticketHistoryPayment.model.js";
class y extends t {
  adapt(e) {
    return new n({
      status: e.status,
      timestamp: new Date(e.timestamp * 1e3),
      amount: e.amount,
      currency: e.currency,
      tip: e.tip,
      fee: e.fee,
      estimatedFee: e.estimated_fee,
      paymentId: e.payment_id,
      paymentType: e.payment_type,
      paymentMethodType: e.payment_method_type,
      paymentSubtype: e.payment_subtype,
      paymentMethodEngineType: e.payment_method_engine_type,
      cardBrand: e.card_brand,
      cardFunding: e.card_funding,
      cardCountryCode: e.card_country_code,
      cardDetails: e.card_details
    });
  }
  serialize(e) {
  }
}
export {
  y as TicketHistoryPaymentAdapter
};
//# sourceMappingURL=ticketHistoryPayment.adapter.js.map
